"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colors = _interopRequireDefault(require("../utils/colors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(_colors.default), _propTypes.default.string]),
  customStyle: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  flippable: _propTypes.default.bool,
  focusable: _propTypes.default.bool,
  quietArea: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  src: _propTypes.default.string,
  title: _propTypes.default.string,
  viewBox: _propTypes.default.string
};
var _default = exports.default = propTypes;